export default __webpack_public_path__ + "static/media/academia_3.e2e39c26.jpg";